import React, { Suspense, useState } from "react"
import { AppBar, Tabs, Tab } from "@material-ui/core"
import { TabPanel, useTabStyle } from "App/Component/ui"
import {
  TabTagihan,
  TabDitanggung,
  TabKunjungan,
  TabPenjualan,
  TabBayar,
  TabSummary,
  TabExternal,
} from ".."
import { useContext } from "react"
import { FormContext } from "../../context/FormContext"
import { STATUS_OPEN_DRAFT_TAGIHAN } from "utils/billing"
function a11yProps(index) {
  return {
    id: `tab-panel-${index}`,
    "aria-controls": `TabPanel-${index}`,
  }
}

export default function TabMaster({
  rowsDitanggung,
  setRowsDitanggung,
  setNewDataTabDitanggung,

  rowsKunjungan,
  setNewDataTabKunjungan,
  loadingKunjungan,

  rowsPenjualan,
  setNewDataTabPenjualan,
  loadingPenjualan,

  rowsBayar,
  setNewDataTabBayar,

  rowsExternal,
  setNewDataTabExternal,

  setNewDataTabTagihan,

  setShowModalKwitansi,
  setNilaiKwitansi,
}) {
  const classes = useTabStyle()
  const [value, setValue] = useState(0)
  const { formData } = useContext(FormContext)
  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  return (
    <Suspense fallback={<div> Loading Tab Master Component...</div>}>
      <div className={classes.root}>
        <div className={classes.rootTab}>
          <AppBar
            position="static"
            classes={{
              root: classes.appbar,
            }}
          >
            <Tabs
              value={value}
              onChange={handleChange}
              variant="fullWidth"
              aria-label="Tabs Input Penjualan"
              classes={{
                root: classes.tabs,
                flexContainer: classes.fixedTab,
              }}
            >
              <Tab
                classes={{
                  selected: classes.selected,
                  fullWidth: classes.tab,
                }}
                label="TAGIHAN"
                {...a11yProps(0)}
              />
              <Tab
                classes={{
                  selected: classes.selected,
                  fullWidth: classes.tab,
                }}
                label="KUNJUNGAN"
                {...a11yProps(1)}
              />
              <Tab
                classes={{
                  selected: classes.selected,
                  fullWidth: classes.tab,
                }}
                label="EXTERNAL"
                {...a11yProps(2)}
              />
              <Tab
                classes={{
                  selected: classes.selected,
                  fullWidth: classes.tab,
                }}
                label="PENJUALAN"
                {...a11yProps(3)}
              />

              <Tab
                classes={{
                  selected: classes.selected,
                  fullWidth: classes.tab,
                }}
                label="DITANGGUNG"
                {...a11yProps(4)}
              />

              {formData.status_tagihan !== STATUS_OPEN_DRAFT_TAGIHAN && (
                <Tab
                  classes={{
                    selected: classes.selected,
                    fullWidth: classes.tab,
                  }}
                  label="BAYAR"
                  {...a11yProps(5)}
                />
              )}

              <Tab
                classes={{
                  selected: classes.selected,
                  fullWidth: classes.tab,
                }}
                label="SUMMARY"
                {...a11yProps(6)}
              />
            </Tabs>
          </AppBar>
          <TabPanel value={value} index={0}>
            <TabTagihan setNewData={setNewDataTabTagihan} />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <TabKunjungan
              rows={rowsKunjungan}
              setNewData={setNewDataTabKunjungan}
              loading={loadingKunjungan}
              rowsExternal={rowsExternal}
            />
          </TabPanel>

          <TabPanel value={value} index={2}>
            <TabExternal
              rows={rowsExternal}
              setNewData={setNewDataTabExternal}
              rowsKunjungan={rowsKunjungan}
            />
          </TabPanel>

          <TabPanel value={value} index={3}>
            <TabPenjualan
              rows={rowsPenjualan}
              setNewData={setNewDataTabPenjualan}
              loading={loadingPenjualan}
            />
          </TabPanel>
          <TabPanel value={value} index={4}>
            <TabDitanggung
              rows={rowsDitanggung}
              setRows={setRowsDitanggung}
              setNewData={setNewDataTabDitanggung}
            />
          </TabPanel>

          <TabPanel value={value} index={5}>
            {formData.status_tagihan === STATUS_OPEN_DRAFT_TAGIHAN ? (
              <TabSummary />
            ) : (
              <TabBayar
                rows={rowsBayar}
                setNewData={setNewDataTabBayar}
                setShowModalKwitansi={setShowModalKwitansi}
                setNilaiKwitansi={setNilaiKwitansi}
              />
            )}
          </TabPanel>

          <TabPanel value={value} index={6}>
            <TabSummary />
          </TabPanel>
        </div>
      </div>
    </Suspense>
  )
}
